import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template"]

  addField(event) {
    event.preventDefault()
    const content = this.templateTarget.content.cloneNode(true)
    const newField = document.createElement('div')
    newField.innerHTML = content.innerHTML
    
    // Insert before the add button
    event.currentTarget.parentElement.insertBefore(newField, event.currentTarget)
    
    // Focus the new input
    newField.querySelector('input').focus()
  }

  removeField(event) {
    event.preventDefault()
    const field = event.currentTarget.closest('.flex')
    field.classList.add('opacity-0', 'scale-95')
    field.style.transition = 'all 100ms ease-in'
    
    setTimeout(() => {
      field.remove()
    }, 100)
  }
}
